import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { loadUser, OidcProvider, processSilentRenew } from 'redux-oidc'
import configureStore from './store/configureStore'
import App from './App'
import registerServiceWorker, {
  unregister as unregisterServiceWorker
} from './registerServiceWorker'
import userManager, { isSilentRefresh } from './userManager'
import LocaleProvider from './components/Translation/LocaleProvider'

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')
const history = createBrowserHistory({ basename: baseUrl })

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState
export const store = configureStore(history, initialState)

if (isSilentRefresh) {
  processSilentRenew()
} else {
  loadUser(store, userManager)

  const rootElement = document.getElementById('root')

  ReactDOM.render(
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <Router history={history}>
          <ConnectedRouter history={history}>
            <LocaleProvider>
              <App />
            </LocaleProvider>
          </ConnectedRouter>
        </Router>
      </OidcProvider>
    </Provider>,
    rootElement
  )
}

//registerServiceWorker()
unregisterServiceWorker()
